import CheckCircleIcon from '@mui/icons-material/CheckCircleOutlined';
import ErrorIcon from '@mui/icons-material/ErrorOutlineOutlined';
import SearchOffIcon from '@mui/icons-material/SearchOffOutlined';

import { ListState } from '@/components/feedback/ListState';

/**
 * Nothing outstanding — the goal state, not a void.
 *
 * The legacy table showed react-data-table's default "There are no records to
 * display" here, which reads as a system with no data rather than a director
 * with no work.
 */
export const OutstandingEmpty = () => (
  <ListState
    tone="success"
    icon={<CheckCircleIcon />}
    title="You're all caught up"
    body="Nothing needs your signature or payment right now. We'll email you when something does."
  />
);

interface NoMatchesProps {
  onClear: () => void;
  /** Set when rendered inside the list panel, which draws its own edge. It is
   *  also shown standalone — before the panel exists — so this cannot be
   *  hardcoded either way. */
  bare?: boolean;
}

/** Distinct from "all caught up": the director has work, just not in this
 *  filter. Telling them they are done would be a lie. */
export const OutstandingNoMatches = ({ onClear, bare = false }: NoMatchesProps) => (
  <ListState
    bare={bare}
    icon={<SearchOffIcon />}
    title="No matching items"
    body="Nothing here matches your current search and filters."
    actionLabel="Clear filters"
    onAction={onClear}
  />
);

interface ErrorStateProps {
  onRetry: () => void;
}

export const OutstandingError = ({ onRetry }: ErrorStateProps) => (
  <ListState
    tone="error"
    icon={<ErrorIcon />}
    title="Couldn't load your outstanding items"
    body="The list didn't load. Check your connection and try again."
    actionLabel="Try again"
    onAction={onRetry}
  />
);
